export const FETCH_INVENTORYSUMMERY_REQUEST = "FETCH_INVENTORYSUMMERY_REQUEST";
export const FETCH_INVENTORYSUMMERY_SUCCESS = "FETCH_INVENTORYSUMMERY_SUCCESS";
export const FETCH_INVENTORYSUMMERY_FAILURE = "FETCH_INVENTORYSUMMERY_FAILURE";
